export const convertDataToForm = (data: any) => ({
  email: data.email.toLowerCase(),
  password: data.password,
});
